export const removeEmptyFromObject = obj => (
  obj && Object.keys(obj)
    .filter(k => obj[k] != null)
    .reduce(
      (newObj, k) =>
        typeof obj[k] === "object"
          ? { ...newObj, [k]: removeEmptyFromObject(obj[k]) }
          : { ...newObj, [k]: obj[k] },
      {}
    )
);
